import YwSearchGroup from "./src/index.vue";
import {
	Select,
	Cascader,
	DatePicker,
	Modal,
	Input,
  Row,
  Col,
  Button,
  TreeSelect,
  FormModel,
  Checkbox,
} from "ant-design-vue";
const { Item } = FormModel;
const { RangePicker } = DatePicker;
const { Group: CheckboxGroup } = Checkbox;
const { Option } = Select;

YwSearchGroup.install = function (Vue) {
	Vue.use(Select);
	Vue.use(Cascader);
	Vue.use(DatePicker);
	Vue.use(Modal);
	Vue.use(Input);
	Vue.use(Row);
	Vue.use(Col);
	Vue.use(Button);
	Vue.use(TreeSelect);
	Vue.use(FormModel);
	Vue.use(CheckboxGroup);
	Vue.use(Option);

	Vue.component(YwSearchGroup.name, YwSearchGroup);
};

export default YwSearchGroup;
